import React from "react";
import { useTranslation } from "react-i18next";
import introPhoto from "../../img/experience/intro-photo.webp";

function Intro() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col-reverse xl:flex-row xl:items-center gap-[40px] xl:gap-[103px]">
        {/* Photo */}
        <div className="w-full xl:w-[600px] xl:h-[443px] xl:shrink-0 h-[260px] rounded-[20px] overflow-hidden">
          <img src={introPhoto} alt="" className="w-full h-full object-cover" />
        </div>

        {/* Text */}
        <div className="flex flex-col gap-[40px] xl:gap-[60px] xl:w-[517px]">
          <div className="flex flex-col font-['Montserrat'] font-black tracking-[-0.92px] uppercase leading-none text-[#0a0a0a]">
            <span className="text-[14px] xl:text-[20px]">{t("exp.intro.pretitle")}</span>
            <span className="text-[24px] xl:text-[46px]">{t("exp.intro.title")}</span>
          </div>
          <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4]">
            {t("exp.intro.desc")}
          </p>
        </div>
      </div>
    </section>
  );
}

export default Intro;
